var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-detail-page"},[_c('headerView',{attrs:{"seletedindex":_vm.seletedindex}}),_c('div',{staticClass:"banner",style:({
      backgroundImage:
        'url(' +
        _vm.contactUsBanner.imgUrl +
        ')',
    })}),_c('div',{staticClass:"business-detail-section"},[_c('div',{staticClass:"business-detail-container"},[_c('h2',{staticClass:"business-detail-title"},[_vm._v(_vm._s(_vm.businessDetail.title))]),_c('div',{staticClass:"business-detail-content",domProps:{"innerHTML":_vm._s(_vm.businessDetail.content)}})])]),_c('footerView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }